<app-scanner></app-scanner>

<div class="home-header">
  <app-info-bar></app-info-bar>
  <app-message-bar></app-message-bar>
</div>

<div class="home-content">
  <app-tour-stop-card
    *ngFor="let tourStop of tourStops"
    [tourStop]="tourStop"
  ></app-tour-stop-card>
</div>

<div class="home-footer">
  <button
    class="transport-plan-button"
    mat-icon-button
    [disabled]="toolbar.navigationBlocked$ | async"
    (click)="openTransportPlan()"
  >
    <mat-icon fontSet="material-icons-outlined">find_in_page</mat-icon>
  </button>
  <button
    *ngIf="tourService.isStarted && subsequentDeliveriesBarcode"
    class="subsequent-deliveries-button"
    mat-icon-button
    (click)="openSubsequentDeliveries()"
  >
    <mat-icon svgIcon="subsequent-deliveries"></mat-icon>
  </button>
</div>
